var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"wizard-tab-container",attrs:{"id":_vm.tabId,"aria-hidden":!_vm.active,"aria-labelledby":`step-${_vm.tabId}`,"role":"tabpanel"}},[_vm._t("default",null,{"active":_vm.active})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }